import {
  Typography as MUITypography,
  TypographyProps,
} from "@material-ui/core";
import classnames from "classnames";
import { forwardRef } from "react";
import { useStyles } from "./styles";

interface Props extends TypographyProps {
  underline?: boolean;
  component?: string;
}

const Typography = forwardRef<HTMLElement, Props>((props, ref) => {
  const { children, underline, className, ...rest } = props;

  const classes = useStyles({ underline });

  const rootClassName = classnames(
    {
      [classes.underline]: underline,
    },
    className,
  );

  return (
    <MUITypography
      ref={ref}
      classes={{
        root: rootClassName,
      }}
      {...rest}
    >
      {children}
    </MUITypography>
  );
});

export default Typography;
